// import { createChatBotMessage } from 'react-chatbot-kit';

// const config = {
//   initialMessages: [createChatBotMessage(`Hello world`)],
// };

// export default config;

import { createChatBotMessage } from "react-chatbot-kit";
import Overview from "./widgets/Overview";

// import LocalStatistics from "./widgets/LocalStatistics";
import Contact from "./widgets/Support";
// import MedicineDelivery from "./widgets/MedicineDelivery";
import CoBotAvatar from "./CoBotAvatar";
import logo from "./images/logoM1.png";
import ProductOverview from "./widgets/ProductOverview";
import DemoForm from "./widgets/DemoForm";
import Features from "./widgets/Features";
import ForSchool from "./widgets/ForSchool";
import PricingWidget from "./widgets/pricingWidget";
import BookDemoOption from "./widgets/BookDemoOption";



const config = {
  lang: "en",
  botName: "Intelle-Bot",
  customStyles: {
    // botMessageBox: {
    //   backgroundColor: "var(--chatbot-message-box)"
    // },
    // chatButton: {
    //   backgroundColor: "red"
    // }
  },
  initialMessages: [
    createChatBotMessage(
      `👋 Hi, welcome to Intelle-Sphere!`
    ),
    createChatBotMessage(
      "We help you learn in-demand skills and connect you with top companies. What would you like to explore today?",
      {
        withAvatar: false,
        delay: 400,
        widget: "overview"
      }
    )
  ],
  state: {
    isTyping: false
  },
  customComponents: { 
    botAvatar: (props) => <CoBotAvatar {...props} /> ,
    header: () => <div style={{ padding: "5px", borderRadius: "3px" }} className="chatbot-header">
      {/* <img src={logo} alt="Intelle-Sphere" style={{ width: "auto", height: "25px" }} /> */}
       Intelle-Bot</div>
  },
  widgets: [
    {
      widgetName: "overview",
      widgetFunc: (props) => <Overview {...props} />,
      props: {},
      mapStateToProps: ["messages"]
    },
 
    {
      widgetName: "ProductOverview",
      widgetFunc: (props) => <ProductOverview {...props} />,
      props: {},
      mapStateToProps: [],
  
    },
    {
      widgetName: "Features",
      widgetFunc: (props) => <Features {...props} />,
      props: {},
      mapStateToProps: [],
  
    },
    {
      widgetName: "ForSchool",
      widgetFunc: (props) => <ForSchool {...props} />,
      props: {},
      mapStateToProps: [],
  
    },
    {
      widgetName: "support",
      widgetFunc: (props) => <Contact {...props} />,
      props: {},
      mapStateToProps: [],
  
    },
    {
      widgetName: "Book a Demo",
      widgetFunc: (props) => <DemoForm {...props} />,
      props: {},
      mapStateToProps: [],
  
    },
    {
      widgetName: "Pricing Widget",
      widgetFunc: (props) => <PricingWidget {...props} />,
      props: {},
      mapStateToProps: [],
  
    },
    {
      widgetName: "bookDemoOption",
      widgetFunc: (props) => <BookDemoOption {...props} />,
      props: {},
      mapStateToProps: [],
  
    },

  ]
};

export default config;
